export default {
    name: 'SocialInformationTooltip',
    props: {
        text: {
            type: String,
            default: 'social network'
        },
        custom: {
            type: Boolean,
            default: false
        }
    }
}
